import isFuture from 'date-fns/is_future'

export default (date) => isFuture(date) ? 'from now' : 'ago';
